import { Title } from "../../components/Title"

export const Spec = () => {
    return (
        <>
            {' '}
            <div className='mx-auto relative mt-12'>
                <Title title='Specs' />
                <div className='flex flex-col pb-12 md:pb-20 font-kiwi text-shadow-white'>
                    <div className='max-w-[1200px] mx-auto'>
                        <div id='spec' className='mt-12'>
                            <div className='container'>
                                <table className='[&>tr>th]:pt-4 [&>tr>th]:md:pt-0 [&>tr]:flex-col [&>tr]:md:table-row [&>tr]:flex [&>tr]:items-center [&>tr>td]:table-cell [&>tr>td]:text-center [&>tr>td]:md:text-left table-auto text-center md:text-left mx-auto decoration-none text-sub md:text-base w-full px-4 xl:px-0 max-w-full font-bold'>
                                    <tr className='w-full'>
                                        <th className='px-2 text-pborange'>Title</th>
                                        <td className=' md:py-2 px-2 pl-4 md:pl-8 '>
                                            <h1>Phantom Brave: The Lost Hero</h1>
                                        </td>
                                    </tr>{' '}
                                    <tr>
                                        <th className='px-2 text-pborange'>
                                            <h1>Release</h1>
                                        </th>
                                        <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>
                                            <div className='flex flex-col'>
                                                <h1>NA: January 30, 2025</h1> <h1>EU: January 30, 2025</h1>{' '}
                                                <h1>ANZ: February 7, 2025</h1> <h1>PC: Spring 2025 (Steam®)</h1>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='md:py-1 px-2  text-pborange'>
                                            <h1>Platforms</h1>
                                        </th>
                                        <td className='md:py-2 px-2 text-left pl-4 md:pl-8  '>
                                            <h1>
                                                {' '}
                                                Nintendo Switch&trade;, PS4®, PS5®, and Steam®
                                                {/* <span className='text-sub mt-12 text-center md:text-right font-bold'>
                                                    *Steam version to follow later in 2025!
                                                </span> */}
                                            </h1>
                                        </td>{' '}
                                    </tr>
                                    <tr>
                                        <th className='md:py-1 px-2  text-pborange'>
                                            <h1>Genre </h1>
                                        </th>
                                        <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>
                                            <h1>Strategy RPG</h1>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='md:py-1 px-2  text-pborange'>
                                            <h1>Players</h1>
                                        </th>
                                        <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>
                                            <h1>1</h1>
                                        </td>
                                    </tr>{' '}
                                    <tr>
                                        <th className='md:py-1 px-2  text-pborange'>
                                            <h1>Text Languages</h1>
                                        </th>
                                        <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>
                                            <h1>English, French</h1>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='md:py-1 px-2  text-pborange'>
                                            <h1>Audio Languages</h1>
                                        </th>
                                        <td className='md:py-2 px-2 pl-4 md:pl-8 '>
                                            <h1>English, Japanese</h1>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='md:py-1 px-2  text-pborange'>
                                            <h1>Developer</h1>
                                        </th>
                                        <td className='md:py-2 px-2 pl-4 md:pl-8 '>
                                            {' '}
                                            <h1>Nippon Ichi Software, Inc.</h1>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
